import { useMemo } from "react";

import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  time: `DateTimePickerTime`
};

export function useDateTimePickerStyles() {
  return useMemo(
    () => mergeStyleSets({
      time: [
        classNames.time,
        {
          width: `100px`
        }
      ]
    }),
    []
  );
}
